export default __webpack_public_path__ + "static/media/mb-cta-chevron-dark.208e872c.svg";